import { isNil, isNull, omit } from 'lodash';
import isFuture from 'date-fns/isFuture';
import { AssetIconKeys, AssetIconNames } from './enums';

export const buildModuleMap = (filteredIds: any[], date: string) =>
  filteredIds.reduce((acc: any, curr: any, idx: number) => {
    return {
      ...acc,
      [curr?.name]: {
        date,
        ...acc?.[curr.name],
        ...curr,
        moduleIds: [...(acc?.[curr?.name]?.moduleIds ?? []), curr?.id]
      }
    };
  }, {});

export const buildCheckedModuleMap = (data: any, modulesData: any) => {
  const result = Object.values(omit(data, '*')).reduce((acc: any, current: any) => {
    acc.push({
      ...current,
      ...(current.checked === true && {
        ids: modulesData?.keyboardingModules
          .filter((m: any) => m.name === current.submodule && !isNull(current.parentModuleId))
          .map((x: any) => x.id)
      })
    });

    return acc;
  }, []);

  return result;
};

export const sanitizeFutureDates = (data: any[]) => {
  return data
    ?.map(({ __typename, isFuture, ...x }: any) => x)
    .filter((x: any) => x.moduleIds.length);
};

/** mutates input */
export const sortByDate = (futureDates: any[]) => {
  return futureDates.sort((d1, d2) => new Date(d1.date).getTime() - new Date(d2.date).getTime());
};

export const hasFutureDates = (scheduledDates: any[]) => {
  return scheduledDates?.some((s: any) => isFuture(new Date(s.date)));
};

export const getHasChecked = (data: Record<string, any>) => {
  return !Object.keys(data).find((k: any) => {
    return Object.values(data[k]).some((x: any) => x.checked === true);
  });
};

export const buildMultiSelected = (idx: number, state: any) => {
  const hasCheckedModule = Object.values(state?.[idx] ?? {}).some((x: any) => x.checked === true);
  return hasCheckedModule
    ? Object.values(state?.[idx] ?? {})
        .filter((x: any) => x.checked)
        .map((x: any) => x.name)
        .join(',')
    : 'Select a Module';
};

export const filterNillFromModules = (modules: any[], moduleMap: any) => {
  return modules
    ?.map((m: any) => moduleMap?.[m.submodule] && { ...moduleMap?.[m.submodule], ...m })
    .filter(x => !isNil(x));
};

export const assetMap: any = {
  [AssetIconKeys.Module1]: AssetIconNames.Module1,
  [AssetIconKeys.Module2]: AssetIconNames.Module2,
  [AssetIconKeys.Module3]: AssetIconNames.Module3
};

export const omitLast = (modules?: any[]) => {
  return modules?.slice(0, -1);
};
